import './App.css';
import Header from './Components/Header/Header';
import Shop from './Components/Shop/Shop';


function App() {
  return (
    <div>
      <Header></Header>
      <Shop></Shop>

    </div>
  );
}

export default App;
